import React, { useEffect, useRef, useState } from 'react';

import { observer } from 'mobx-react-lite';
import {
  FreeBetMaxPayoutPopUp,
  LocalStorageWrapper,
  MaxWinPopup,
  platformMessageStore,
} from '@pascal/pascal-core';

import { gameDrawer } from '../drawers/gameDrawer';

import BetSection from '../../components/betSection';
import { RoundTime } from '../../components/roundTime';
import { getScreenResolution } from '../../helpers/getScreenResolution';
import { specificLocalStorageKeys } from '../../enums/gameConstant';
import MultiplierNotePopup from '../../components/multiplierNotePopup';

export const MobileGameScene = observer(() => {
  const ref = useRef();
  const [style, setStyle] = useState({});
  const { isRepliedGame } = platformMessageStore;

  useEffect(() => {
    if (!ref.current) return;
    setStyle(getScreenResolution());
    gameDrawer.setupRoot(ref.current);
    // eslint-disable-next-line
  }, [ref.current]);

  return (
    <div className='m-catch-me-game'>
      <div className='m-catch-me-game-top-holder'>
        <RoundTime />
        <MaxWinPopup />
        <FreeBetMaxPayoutPopUp />
        <div className='canvas-holder' style={style} ref={ref} />
        <div className='canvas-second-layer' />
        {!isRepliedGame && (
          <LocalStorageWrapper localStorageKey={specificLocalStorageKeys.isMultiplierPopUpSeen}>
            <MultiplierNotePopup />
          </LocalStorageWrapper>
        )}
      </div>
      <BetSection />
    </div>
  );
});
